import { defineMessages } from '@shared/i18n/messages';
import defaultMessages from '@declaration/assets/lang/fr.declaration.json';
export default defineMessages('fr', 'declaration', defaultMessages);
